import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M11.93 8.25h.02c.2-.01.42.06.58.22l5.86 5.86a.75.75 0 11-1.06 1.06l-5.4-5.4-5.4 5.4a.75.75 0 01-1.06-1.06l5.86-5.86a.75.75 0 01.6-.22z' />
  </svg>
);
